<template>
  <div>
    <div class="main_form">
      <div>
        <div class="title_box">
          <!-- 操作按钮部分 -->
          <div class="operation_box">
            <el-button @click="addExaminee">
              <img src="@/assets/button_imgs/tianjia.png" alt="" />添加考生
            </el-button>
            <el-button @click="delectArr()">
              <img src="@/assets/button_imgs/shangchuang.png" alt="" />批量删除
            </el-button>
          </div>
          <!-- 账号搜索 -->
          <div class="search_view">
            <div class="search">
              <el-input
                v-model="input"
                placeholder="根据考生姓名或账号搜索"
                type="text"
              ></el-input>
              <el-button @click="searchResult" icon="el-icon-search">
                <!-- <i class="iconfont icon-sousuo"></i> -->
              </el-button>
            </div>
            <el-button @click="reset" icon="el-icon-refresh" class="searchbtn">
              重置
            </el-button>
          </div>
        </div>
        <!-- 表格 -->
        <div class="examinee_form">
          <p>已选{{ getData.length }}人，科室{{ this.unique() }}个</p>
          <el-table
            ref="tabledata"
            :data="list_vip"
            style="width: 100%"
            height="710"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            @row-click="StepsListRowClick"
            :header-cell-style="{
              'background-color': '#EEEEEE',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="selection" width="80"></el-table-column>
            <el-table-column type="index" label="序号"> </el-table-column>
            <el-table-column
              v-for="(item, index) in formColumns"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              height="150"
              label-height="50"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="address" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click.stop="delectstudent(scope.row, scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <FourPup ref="popup" :currentRow="currentRow" />
  </div>
</template>

<script>
import resourcereq from "@/api/resources";
import FourPup from "@/components/progress/FourPup.vue"; //添加考生的弹窗
import assessApi from "@/api/assessment";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      progressdialog: {
        isshow: false,
        percentagenum: 0,
      }, //进度弹窗
      // sundflag: false, // 提交的防抖
      input: "",
      textarea: "",
      reducesum: "", //总分
      inputtestname: "", //考试名称
      activeNames: ["1"],
      isactiveNames: ["1"],
      value1: [], //开始和结束的时间
      StartDatestr: "", //开始的时间
      EndDate: "", //
      textarea2: " ", //注意事项
      getData: [],
      currentPage3: 0, //  当前页数
      pageSize: 10,
      total: 100,
      currentRowData: {}, //
      currentRow: {}, //删除的对象。
      hid: "",
      formColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室名称",
          // width: "90px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "Position",
          label: "职位",
          // width: "90px",
        },
        {
          prop: "Birthday1",
          label: "出生日期",
          width: "200px",
        },
        {
          prop: "JobDate",
          label: "工作年限",
          // width: "90px",
        },
      ],
      options: [
        //切屏次数的选项
        {
          value: "0",
          label: "0",
        },
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
      ],
      cutscreen: 0, //切屏次数
      cheat_pwdinput: "", //防作弊六位数字密码
      // checkcode: isbotainData,
      rendersum: [],
      multipleSelection: [],
      client: null, //oss对象
      filestatus: "",
      checkpoint: "",
      percentage: 0,
      list_vip: [], // 新定义的数组
      typeState: "", // 是否编辑状态 1为编辑
    };
  },
  components: {
    FourPup,
  },
  props: ["editorObj"],
  methods: {
    // 重置
    reset() {
      this.input = "";
      this.isShow = false;
      this.searchResult();
    },
    // 搜索查询
    searchResult() {
      let articles_array = JSON.parse(JSON.stringify(this.getData)); // 一进来获取的列表数据
      let searchString = this.input; // input的数据
      if (searchString == "") {
        // 传空值的时候展示全部
        this.isShow = false;
        this.list_vip = articles_array;
      } else {
        this.isShow = true; // 展示查询出来的表格
        searchString = searchString.trim().toLowerCase();
        articles_array = articles_array.filter((item) => {
          return JSON.stringify(item).indexOf(searchString) != -1;
        });
        if (this.list_vip.length == 0) {
          this.$message.error(`未找到包含“${this.input}”信息的考生!`);
          this.list_vip = JSON.parse(JSON.stringify(this.getData));
        } else {
          this.list_vip = articles_array;
        }
      }
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    handleChange(val) {
      console.log(val);
    },

    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      // this.getDateList(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val;
      this.rendersum = this.pageData(this.currentPage3, 10, this.getData);
    },
    pageData: (number, pageSize, data) => {
      const pageList = [];
      const start = pageSize * number - pageSize;
      const end = pageSize * number;
      for (let i = start; i < end; i++) {
        pageList.push(data[i]);
      }
      const list = pageList.filter((item) => item);
      return list;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    back() {
      this.$parent.cutcoms(0);
    },
    async checkfilename() {
      let parmas = {
        name: this.$parent.$children[0].fileurl,
        hid: this.hid,
        _examID: "",
      };
      let res = await resourcereq.checkfilename(parmas);
      return res.data.Status;
      //  console.log(res);
    },
    // 去重
    unique() {
      let departArr = this.getData.map((item) => {
        return item.DepartmentName;
      });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    // 添加科室
    async addExaminee() {
      this.$refs.popup.cancel(); // 8.11 清除子组件勾选缓存
      this.$refs.popup.submit();
      this.$refs.popup.dialogVisibleObj.addExamineeShow = true;
    },
    //批量删除
    delectArr() {
      if (this.multipleSelection.length < 1) {
        this.$refs.popup.deleteState = 2;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      } else {
        this.$refs.popup.deleteState = 1;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      }
    },

    delectstudent(row, val) {
      // this.getData.splice(val, 1);
      // console.log("删除考生" + val);
      this.currentRowData = row;
      let userID = row.UserName; // 根据考试账号去删除
      let index = this.getData.findIndex((zitem) => {
        // 找到对应的索引删除
        return userID == zitem.UserName;
      });
      this.currentRow = index;
      this.currentRowData.index = val;
      this.$refs.popup.deleteState = 0;
      this.$refs.popup.dialogVisibleObj.batchDelete = true;
    },
    // 获取编辑数组
    async getEditorArr() {
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        let obj = {
          userType: "student", // teacher监考人员 student 考生
          examineID: this.$route.query.ID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
          userID: JSON.parse(loginvuex.state.userlist).userID,
        };
        const { data } = await assessApi.getDetailsArr(obj);
        if (data.Status == 200) {
          this.list_vip = data.Data.map((item) => {
            item.Birthday1 = this.$moment(item.BeginTime).format(
              "YYYY/MM/DD HH:mm"
            );
            return item;
          });
          // this.getData = this.list_vip
          this.getData = JSON.parse(JSON.stringify(this.list_vip));
        } else {
          this.$message.error(data.Msg);
        }
      }
    },
  },
  async created() {
    // console.log(this.$parent.$parent.details);
    this.typeState = this.$route.query.type; // 编辑状态
    this.getEditorArr();
    this.hid = JSON.parse(sessionStorage.getItem("token")).hid;
    // this.list_vip = this.editorObj.student; // 编辑回显
  },
};
</script>

<style lang="scss" scoped>
.father_box {
  margin-top: 24px;
}
.baic_content {
  background-color: white;
  min-width: 1527px;
  border-radius: 4px 4px 4px 4px;
  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-collapse-item__header {
  height: 60px;
  line-height: 60px !important;
  background: #d8edff;
  border-radius: 10px 10px 0px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 19px;
  color: #333333;
  padding: 0px 24px;
}
.main_form {
  border-radius: 13px 13px 0px 0px;
  margin-bottom: 24px;
  ::v-deep .el-collapse-item__arrow {
    font-weight: bolder;
  }
  .son_input {
    .bacle_input {
      align-items: center;
      .standard_input {
        width: 825px;
        height: 40px;
        display: flex;
        align-items: center;
      }
      .text_field {
        width: 673px;
        height: 126px;
      }
      margin-top: 24px;
      padding-right: 40px;
      display: flex;
      p {
        margin-left: 20px;
      }
      h5 {
        min-width: 160px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        text-align: left;
        line-height: 40px;
        padding-left: 20px;
        margin-right: 10px;
        &::before {
          content: "*";
          width: 20px;
          display: inline-block;
          color: #ff0000;
        }
      }
      .icont_pop {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 34px;
          top: 0px;
          color: #d9d9d9;
          font-size: 20px;
          color: #d8edff;
        }
      }
      .icont_hover {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 6px;
          top: 0px;
          color: #d9d9d9;
          font-size: 20px;
          color: #d8edff;
        }
      }
    }
  }
}
.isallowqieping {
  width: 280px;
  display: flex;
  align-items: center;
  margin-left: 170px;
  > p {
    font-size: 16px;
    color: rgb(160, 158, 158);
  }
  .qiepingcishu {
    width: 60px;
  }
}
.cheat_pwdinput {
  width: 200px;
  margin-left: 170px;
  margin-top: 10px;
}
.special_input {
  display: flex;
  margin-top: 24px;
  .special_box {
    width: 673px;
    height: 126px;
  }
  h5 {
    min-width: 160px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
}
.title_box {
  display: flex;
  justify-content: space-between;
  margin: 24px 16px 24px 24px;

  .search_view {
    display: flex;
    .search {
      display: flex;
      width: 300px;
      height: 40px;
      .el-button {
        width: 40px;
        height: 40px;
        background: #1890ff;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #1890ff !important;
        border-radius: 0px 4px 4px 0px !important;
        i {
          display: inline-block;
        }
      }

      ::v-deep .el-input__inner {
        border-radius: 4px 0px 0px 4px !important;
      }
    }
  }
  .searchbtn {
    margin-left: 14px;
    margin-right: 12px;
    height: 40px;
  }
}
// 按钮
.operation_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 112px;
    height: 40px;
    background: #ebecf1;
    border-radius: 3px;
    letter-spacing: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: #000000;
    span {
      display: flex;
      align-items: center;
    }
    span > img {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
}
// 表单
.examinee_form {
  padding: 0 24px;
  p {
    padding: 10px 24px;
    height: 42px;
    background: #eef7ff;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    font-weight: 400;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;

  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  ::v-deep .el-pagination__jump {
    &::before {
      content: "10条/页";
      width: 82px;
      border: 1px solid #d9d9d9;
      height: 28px;
      border-radius: 2px;
      text-align: center;
      display: inline-block;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}
</style>
